// extracted by mini-css-extract-plugin
module.exports = {"outer":"_2Q6g3"};